import React from 'react';

export default ({ onClose }) => (
  <div className="ms__request__confirmation">
    <h3>Adding Your Swing</h3>
    <p>When you close this message, upload your swings in the "Your Submittals" section on the bottom of this page.</p>
    <button type="button" className="button button--theme--outline" onClick={onClose}>
      Got it!
    </button>
  </div>
);



// WEBPACK FOOTER //
// ./src/subscription/coaching/swing-submittals/SwingSubmittalPurchaseSuccess.js